"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var abstract_linkage_1 = require("./abstract-linkage");
var SingleLinkage = /** @class */ (function (_super) {
    __extends(SingleLinkage, _super);
    function SingleLinkage(distanceFunc) {
        return _super.call(this, distanceFunc) || this;
    }
    SingleLinkage.prototype.calculate = function (c1, c2) {
        var result = Infinity;
        for (var _i = 0, _a = c1.clusterElements(); _i < _a.length; _i++) {
            var e1 = _a[_i];
            for (var _b = 0, _c = c2.clusterElements(); _b < _c.length; _b++) {
                var e2 = _c[_b];
                result = Math.min(result, this.distanceFunc(e1, e2));
            }
        }
        return result;
    };
    return SingleLinkage;
}(abstract_linkage_1.AbstractLinkage));
exports.SingleLinkage = SingleLinkage;
